import { IPromise, IQService } from "angular";
import { orderBy } from "lodash";

export interface AllItemsServerConfig {
  queryMethod: string;
  saveMethod: string;
  orderField?: string;
}

export class AllItemsServer {
  private readonly resultPromise: IPromise<void>;
  private items: any[] | undefined;

  constructor(
    private readonly server: any,
    private readonly config: AllItemsServerConfig,
    $q: IQService
  ) {
    this.resultPromise = $q.when(this.fetchAll()).then((items) => {
      this.items = orderBy(items.map(this.mapToInternalItem), (r) =>
        config.orderField ? r[config.orderField] : r.searchString
      );
    });
  }

  async fetchAll() {
    const query = { Take: 10000, OrderBy: "Id", Skip: 0 };
    let fetchedCount = 0;
    let total = 0;
    const allItems: any[] = [];

    do {
      // eslint-disable-next-line no-await-in-loop
      const results = await this.server[this.config.queryMethod]({
        ...query,
        Skip: query.Skip + allItems.length,
      });
      allItems.splice(allItems.length, 0, ...results.Results);
      total = results.Total;
      fetchedCount = results.Results.length;
    } while (fetchedCount > 0 && allItems.length < total);

    return allItems;
  }

  mapToInternalItem(item: any) {
    return {
      ...item,
      searchString: item.Name.toLowerCase(),
    };
  }

  mapToQueryResult(items: any[]) {
    return {
      Results: items,
    };
  }

  search(query: string) {
    return this.resultPromise.then(() => {
      const matchingItems =
        this.items?.filter((i) =>
          i.searchString.includes(query.toLowerCase())
        ) ?? [];
      return this.mapToQueryResult(matchingItems);
    });
  }

  add(name: string) {
    return this.server[this.config.saveMethod]({
      Name: name,
    }).then((i: any) => {
      const newItem = this.mapToInternalItem(i);
      const items = this.items ?? [];
      const insertBeforeThisItem = items.find(
        (existingItem) => newItem.searchString < existingItem.searchString
      );
      const beforeIndex = insertBeforeThisItem
        ? items.indexOf(insertBeforeThisItem)
        : items.length;
      items.splice(beforeIndex, 0, newItem);
      return newItem;
    });
  }
}
